import type { IconSvgObject } from './types';

const LeftTriangleIcon: IconSvgObject = [
  ["path", { d: "M19.2932 14.293H16.2932C15.1886 14.293 14.2932 15.1884 14.2932 16.293V19.293", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.2932 10.2882L20.2999 10.2884C19.7477 10.2885 19.3001 10.7362 19.3001 11.2884V18.2881C19.3001 18.8404 18.8524 19.2881 18.3001 19.2881H11.2977C10.7454 19.2881 10.2977 19.7359 10.2977 20.2881V21.293M19.2932 6.78882L19.2971 3.71031C19.2982 2.81897 18.2207 2.37164 17.5902 3.00168L3.00197 17.5793C2.37162 18.2092 2.81777 19.2868 3.70889 19.2867L6.79319 19.2865", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LeftTriangleIcon;
